import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  ElementRef,
  Renderer2,
  HostListener
} from '@angular/core';

@Directive({
  selector: '[cpdTooltip]'
})
export class CustomTooltipDirective {
  @Input('cpdTooltip') public tooltipTemplate: TemplateRef<any>;
  @Input() public tooltipDisabled = false;

  private tooltipContainer: HTMLElement;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef
  ) {}

  @HostListener('mouseenter') public onMouseEnter(): void {
    if (!this.tooltipContainer && !this.tooltipDisabled) {
      this.showTooltip();
    }
  }

  @HostListener('mouseleave') public onMouseLeave(): void {
    if (this.tooltipContainer && !this.tooltipDisabled) {
      this.hideTooltip();
    }
  }

  private showTooltip(): void {
    this.tooltipContainer = this.renderer.createElement('div');
    this.renderer.appendChild(
      this.tooltipContainer,
      this.viewContainerRef.createEmbeddedView(this.tooltipTemplate)
        .rootNodes[0]
    );
    this.renderer.appendChild(document.body, this.tooltipContainer);

    this.renderer.setStyle(this.tooltipContainer, 'opacity', '0');
    this.renderer.setStyle(this.tooltipContainer, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipContainer, 'z-index', '1050');
    this.renderer.setStyle(this.tooltipContainer, 'pointer-events', 'none');
    this.renderer.setStyle(this.tooltipContainer, 'transition', 'all 0.2s');
    this.renderer.setStyle(this.tooltipContainer, 'transform', 'scale(0.8)');

    const hostPos = this.elementRef.nativeElement.getBoundingClientRect();
    const tooltipPos = this.tooltipContainer.getBoundingClientRect();

    const top = hostPos.top - tooltipPos.height + window.scrollY;
    const left =
      hostPos.left +
      (hostPos.width - Math.min(tooltipPos.width, 260)) / 2 +
      window.scrollX;

    this.renderer.setStyle(this.tooltipContainer, 'top', `${top}px`);
    this.renderer.setStyle(this.tooltipContainer, 'left', `${left}px`);

    this.renderer.setStyle(this.tooltipContainer, 'opacity', '1');
    this.renderer.setStyle(this.tooltipContainer, 'transform', 'scale(1)');
  }

  private hideTooltip(): void {
    this.renderer.setStyle(this.tooltipContainer, 'opacity', '0');
    this.renderer.setStyle(this.tooltipContainer, 'transform', 'scale(0.8)');

    if (this.tooltipContainer) {
      this.renderer.removeChild(document.body, this.tooltipContainer);
      this.tooltipContainer = null;
    }
  }
}
